import { forwardRef } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import styled, { css } from 'styled-components';
import { parseAlignProp } from "../props/AlignProps.js";
import { parseResponsiveProp } from "../props/ResponsiveProp.js";
import { parseSpaceProp } from "../props/SpaceProp.js";
import { jsx as _jsx } from "react/jsx-runtime";
function stackItemMixin(space, align) {
  return css(["flex-direction:column;align-items:", ";display:", ";&:empty{display:none;}&:not(:empty) ~ div{padding-top:", "px;}"], parseAlignProp(align), align === 'left' ? 'block' : 'flex', parseSpaceProp(space));
}
var StackRoot = /*#__PURE__*/styled.div.withConfig({
  displayName: "Stack__StackRoot",
  componentId: "SD__sc-qkml7c-0"
})(_ref => {
  var {
    theme,
    space,
    align
  } = _ref;
  return css(["width:100%;& > div{", ";", "{", ";}", "{", ";}}"], stackItemMixin(space[0], align[0]), theme.breakpoints.up('sm'), stackItemMixin(space[1], align[1]), theme.breakpoints.up('md'), stackItemMixin(space[2], align[2]));
});
export var Stack = /*#__PURE__*/forwardRef((_ref2, ref) => {
  var {
    children,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    space = 'xsmall',
    align = 'left'
  } = _ref2;
  return /*#__PURE__*/_jsx(StackRoot, {
    ref: ref,
    align: parseResponsiveProp(align),
    space: parseResponsiveProp(space),
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    children: flattenChildren(children).map((child, idx) => /*#__PURE__*/_jsx("div", {
      children: child
    }, idx))
  });
});
if (process.env.NODE_ENV !== "production") Stack.displayName = "Stack";